export const resize = () => (
  <path
    d="M 5.63668 15.5356 L 15.5362 5.63611 M 9.87887 15.5356 L 15.5357 9.87875"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
